module.exports = __webpack_public_path__ + "static/media/PLANCHAVAR_MENU-normal.de3a49e1.png";